<template>
  <div class="offer">
    <el-row>
      <el-col class="offer-left">
        <h2>人才招聘</h2>
        <p class="underline"></p>
        <p class="offer-p">Recruitment</p>
      </el-col>
      <el-col class="offer-right" v-if="swiperShow" @mouseenter.native="mouseOver" @mouseleave.native="mouseOver">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide v-for="(item,index) of recruitList" :key="'recruit-'+index">
            <!--<p class="date">2017.06.29</p>-->
            <h3>{{item.name_ch}}</h3>
            <p class="under"></p>
            <p class="p_">{{item.remark}}</p>
            <el-button type="text" class="more" :data-obj="JSON.stringify(item)">
              查看更多
              <img src="../../assets/home/route3.png" alt />
            </el-button>
          </swiper-slide>
        </swiper>
        <div class="btn btn-prev" @click="$refs.mySwiper.$swiper.slidePrev()" v-show="btnShow"></div>
        <div class="btn btn-next" @click="$refs.mySwiper.$swiper.slideNext()" v-show="btnShow"></div>
      </el-col>
    </el-row>
    <el-dialog :visible.sync="dialogVisible" width="500px">
       <!--<p class="date">2017.06.29</p>-->
      <h1>{{showData.name_ch}}</h1>
      <p class="claim">{{showData.required}} | {{showData.degree}} | {{showData.hiring}}名</p>
      <div class="border-line"></div>
      <h6>职位描述</h6>
      <p class="claim-p">{{showData.job_describe}}</p>
      <h6>招聘要求</h6>
      <p class="claim-p">{{showData.job_content}}</p>
      <h6>联系方式</h6>
      <p class="claim-p">
        联 系 人：{{showData.linkman}}
        <br />
        联系电话：{{showData.tel}}
        <br />
        电子邮件：{{showData.email}}
      </p>
    </el-dialog>
  </div>
</template>

<script>
const recruitListUri = "website/index/recruit/get/all";

export default {
  data() {
    return {
      dialogVisible: false,
      swiperShow: false,
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 48,
        loop: false,
        autoplay: {
          delay: 3000
        }
      },
      recruitList: [],
      showData: {},
      btnShow: false
    };
  },
  mounted() {
    this.initEvent();
  },
  created() {
    this.initConfig();
    this.getRecruitList();
  },
  methods: {
    mouseOver() {
      this.btnShow = !this.btnShow;
    },
    showItem() {
      // console.log(this.showData);
      this.dialogVisible = true;
    },
    initConfig() {
      let config = this.$cache.get("recruitConfig");
      if (config) {
        this.swiperOption.autoplay.delay = config.interval_time;
      }
    },
    getRecruitList() {
      this.$api.get(recruitListUri).then(res => {
        if (res.list.length > 2) {
          this.swiperOption.loop = true;
        }
        this.recruitList = res.list;
        this.swiperShow = true;
      });
    },
    // 初始化事件
    initEvent() {
      let btns = document.querySelectorAll(".more");
      btns.forEach(_ => {
        _.addEventListener(
          "click",
          () => {
            this.showData = JSON.parse(_.dataset.obj || "{}");
            this.showItem();
          },
          false
        );
      });
    }
  },
  watch: {
    recruitList() {
      this.$nextTick(() => {
        this.initEvent();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.offer {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  margin-top: 36px;
  .el-row {
    display: flex;
    align-items: center;

    .offer-left {
      width: 362px;
      height: 373px;
      // padding: 100px 48px 0;
      h2 {
        font-size: 30px;
        font-weight: 500;
        color: #333333;
        margin-left: 48px;
        margin-top: 120px;
      }
      .underline {
        width: 24px;
        height: 2px;
        background: #e60616;
        margin: 36px 0 41px 48px;
      }
      .offer-p {
        font-size: 24px;
        color: #999999;
        margin-left: 48px;
      }
    }
    .offer-right {
      width: 850px;
      position: relative;
      .swiper-container {
        margin: 27px 0 27px 48px;
        .swiper-slide {
          width: 261px !important;
          height: 318px;
          border: 1px solid #eeeeee;
          border-radius: 4px;
          padding: 31px 32px 34px 32px;
          .date {
            font-size: 13px;
            color: #999999;
            margin-bottom: 10px;
          }
          h3 {
            font-size: 18px;
            color: #333333;
            font-weight: 500;
          }
          .under {
            width: 12px;
            height: 1px;
            background: #333333;
            margin: 18px 0 14px 0;
          }
          .p_ {
            font-size: 16px;
            color: #555555;
            line-height: 28px;
            height: 112px;
            overflow: hidden;
            display: -webkit-box;//将元素设为盒子伸缩模型显示
            -webkit-box-orient: vertical;//伸缩方向设为垂直方向
            -webkit-line-clamp: 4;//超出3行隐藏，并显示省略号
          }
          .more {
            font-size: 16px;
            color: #e60616;
            margin-top: 32px;
            line-height: 21px;
            img {
              width: 15px;
              height: 5px;
              vertical-align: middle;
              margin-left: 8px;
            }
          }
        }
      }
      .btn {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 32px;
        height: 64px;
        cursor: pointer;
        z-index: 2;
      }
      .btn-prev {
        left: 0;
        background-image: url("../../assets/home/prev2.png");
        background-size: 100% 100%;
      }
      .btn-next {
        right: 0;
        background-image: url("../../assets/home/next2.png");
        background-size: 100% 100%;
      }
    }
  }
  .el-dialog__wrapper {
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      padding: 36px 0 36px 0;
      .date_ {
        font-size: 15px;
        color: #999999;
        margin-bottom: 12px;
        padding: 0 36px;
        line-height: 15px;
      }
      h1 {
        font-size: 30px;
        font-weight: 500;
        color: #333333;
        margin-bottom: 15px;
        padding: 0 36px;
        line-height: 30px;
      }
      .claim {
        font-size: 16px;
        color: #e70818;
        padding: 0 36px;
        line-height: 16px;
      }
      .border-line {
        height: 1px;
        background: #eeeeee;
        margin: 33px 0 32px 0;
      }
      h6 {
        font-size: 20px;
        font-weight: 500;
        color: #333333;
        padding: 0 36px;
        margin-bottom: 8px;
        line-height: 20px;
      }
      .claim-p {
        font-size: 16px;
        color: #555555;
        line-height: 28px;
        padding: 0 36px;
        margin-bottom: 32px;
      }
      .claim-p:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>